import { BorrowerDocumentationRequired, BorrowerFileType, DocumentType, RequiredFile } from '@nemuru-eng/js-api-client';

import {
  BANK_ACCOUNT_DOCUMENT_FILE_TYPES,
  INCOME_DOCUMENT_FILE_TYPES,
  NIE_EU_DOCUMENT_ID_FILE_TYPES,
  NIE_EU_VIDEO_ID_FILE_TYPES,
  NIF_DOCUMENT_ID_FILE_TYPES,
  NIF_VIDEO_ID_FILE_TYPES,
} from '@/components/modules/DocumentsValidation/constants';
import { ValidationStep } from '@/components/modules/DocumentsValidation/types/ValidationStep';

import { PASSPORT_DOCUMENT_ID_FILE_TYPES } from './../constants/index';

export const DocumentationRequiredMap = {
  getFilesByStep: (
    borrowerDocumentationRequired: BorrowerDocumentationRequired,
    step: ValidationStep,
    documentType?: DocumentType,
  ) => {
    const files = borrowerDocumentationRequired.requiredFiles;
    const hasUploadedFiles = (file: RequiredFile) => {
      return file.uploadedFiles && file.uploadedFiles.length > 0;
    };

    if (!files) {
      return;
    }

    if (step === ValidationStep.DOCUMENT_ID_VALIDATION) {
      return files.filter(
        (file) =>
          (documentType === DocumentType.PASSPORT
            ? PASSPORT_DOCUMENT_ID_FILE_TYPES
            : documentType === DocumentType.NIE_EU
            ? NIE_EU_DOCUMENT_ID_FILE_TYPES
            : NIF_DOCUMENT_ID_FILE_TYPES
          ).includes(file.name as BorrowerFileType) && hasUploadedFiles(file),
      );
    }

    if (step === ValidationStep.VIDEO_ID_VALIDATION) {
      return files.filter(
        (file) =>
          (documentType === DocumentType.PASSPORT || documentType === DocumentType.NIE_EU
            ? NIE_EU_VIDEO_ID_FILE_TYPES
            : NIF_VIDEO_ID_FILE_TYPES
          ).includes(file.name as BorrowerFileType) && hasUploadedFiles(file),
      );
    }

    if (step === ValidationStep.INCOME_VALIDATION) {
      return files.filter(
        (file) => INCOME_DOCUMENT_FILE_TYPES.includes(file.name as BorrowerFileType) && hasUploadedFiles(file),
      );
    }

    if (step === ValidationStep.BANK_ACCOUNT_VALIDATION) {
      return files.filter(
        (file) => BANK_ACCOUNT_DOCUMENT_FILE_TYPES.includes(file.name as BorrowerFileType) && hasUploadedFiles(file),
      );
    }

    return;
  },
};
